export default "__VITE_PUBLIC_ASSET__e8dbdae8__"